import { ComponentRef, Directive, ElementRef, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { merge, EMPTY } from 'rxjs';
import { FormErrorComponent } from '../components/form-error/form-error.component';
import { ErrorCodesService } from '../interfaces/error-codes.service';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[formErrorDirective]',
    standalone: false
})
export class FormErrorDirective implements OnInit, OnDestroy {
  @Input('formErrorDirective') controlName!: string;

  private ref?: ComponentRef<FormErrorComponent>;

  public constructor(public el: ElementRef, private viewContainerRef: ViewContainerRef, private controlDir: NgControl, private errorCodes: ErrorCodesService) {}

  ngOnInit(): void {
    merge(this.controlDir?.valueChanges ?? EMPTY).subscribe(() => {
      const controlErrors = this.controlDir?.control?.errors;

      if (controlErrors && this.controlName) {
        const errorFieldName = this.extractNestedControlName(this.controlName);
        const errorKeys = Object.keys(controlErrors);
        this.setError(
          errorKeys.map((x) => {
            if (controlErrors[x]?.requiredLength) {
              return this.errorCodes.getError(x, errorFieldName).replace('{{placeholder}}', controlErrors[x]?.requiredLength);
            }
            if (controlErrors[x].min || controlErrors[x].min === 0) {
              return this.errorCodes.getError(x, errorFieldName).replace('{{placeholder}}', controlErrors[x]?.min);
            }
            if (controlErrors[x].max || controlErrors[x].max === 0) {
              return this.errorCodes.getError(x, errorFieldName).replace('{{placeholder}}', controlErrors[x]?.max);
            }

            return this.errorCodes.getError(x, errorFieldName);
          })
        );
      } else {
        this.setError();
      }
    });
  }

  ngOnDestroy(): void {
    this.ref?.destroy();
  }

  private setError = (texts?: string[]): void => {
    if (!this.ref) {
      this.ref = this.viewContainerRef.createComponent(FormErrorComponent);
    }

    if (texts && this.controlDir.dirty) {
      this.ref.instance.texts = texts;
      this.ref.instance.hide = false;
      this.el.nativeElement.classList.add('border-red');
    } else {
      this.ref.instance.hide = true;
      this.el.nativeElement.classList.remove('border-red');
    }
  };

  private extractNestedControlName(controlName: string): string {
    const formNames = controlName.split('.');

    return formNames[formNames.length - 1];
  }
}
